/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getValues } from 'redux-form';

import { BUSINESS_INTRODUCTION_STEP_ID } from '@src/containers/Routes/helper/stepActiveIds.helper';
import { useNavigateToStep } from '@src/hooks/useNavigateToStep';

import messages from './CompanyDirectorNotice.messages';
import { nextStep } from '../../actions';
import { buildApplicationState } from '../../helpers/applicationManager';
import { isIntroducer } from '../../lendingAPI/lendingAPISelector';

const mapStateToProps = (state) => ({
    isBroker: isIntroducer(state),
    companyName: buildApplicationState(
        state.fetched.application.payload,
        getValues(state.form.sign_up)
    ).company.company_name
});

const mapDispatchToProps = (dispatch) => ({
    nextStep: () => dispatch(nextStep(BUSINESS_INTRODUCTION_STEP_ID))
});

// TODO: Add amplitude tracking to this link.
const CompanyDirectorNotice = ({ isBroker, companyName, nextStep }) => {
    const { navigateToStep } = useNavigateToStep();

    const showCompanySearch = () => {
        nextStep();
        navigateToStep(BUSINESS_INTRODUCTION_STEP_ID);
    };

    if (isBroker) {
        return null;
    }
    const companyNameLink = (
        <a
            data-dd-privacy="mask"
            className="companyDirectorNotice__companyLink fs-exclude"
            onClick={showCompanySearch}>
            <b>{companyName}</b>
        </a>
    );
    return (
        <div data-testid="companyDirectorNotice">
            <FormattedMessage
                {...messages.notice}
                values={{ companyName: companyNameLink }}
            />
        </div>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyDirectorNotice);
